import { Layout, Tabs } from "antd";
import { Organization } from "../../../api";
import { history } from "../../../app/helpers";
import { WaterConsumptionIntakeComponent } from "../waterConsumptionIntakes/WaterConsumptionIntakesComponent";
import { WaterConsumptionHouseholdComponent } from "../waterConsumptionHouseholds/WaterConsumptionHouseholdsComponent";
import { WaterConsumptionProductionComponent } from "../waterConsumptionProductions/WaterConsumptionProductionsComponent";

interface WaterConsumptionComponentProps {
  organization?: Organization;
  year?: number;
}

export const WaterConsumptionComponent: React.FC<WaterConsumptionComponentProps> = ({ organization, year }) => {
  return (
    <>
      <Layout className="bg-white p-4 rounded-lg">
        <Tabs
          tabPosition="left"
          destroyInactiveTabPane={true}
          onChange={(path) => {
            let tabPath = history?.location?.pathname.split('/') || [];
            tabPath[6] = path;
            history.navigate && history.navigate(`${tabPath.join('/')}`);
          }}
          defaultActiveKey={history?.location?.pathname.split('/')[6]}
          items={[
            {
              label: 'Забор воды',
              key: 'waterConsumptionIntake',
              children: <WaterConsumptionIntakeComponent organization={organization} year={year} />,
            },
            {
              label: 'Хозяйственно-бытовое потребление',
              key: 'waterConsumptionHousehold',
              children: <WaterConsumptionHouseholdComponent organization={organization} year={year} />,
            },
            {
              label: 'Производственные',
              key: 'waterConsumptionProduction',
              children: <WaterConsumptionProductionComponent organization={organization} year={year} />,
            },
          ]}
        />
      </Layout>
    </>
  );
};
